import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import SessionsTableRow from './SessionsTableRow';
import { Permission } from "../../../components/SessionInfo";
import OrderCell from "../../../common/components/OrderCell/OrderCell";

const sticky = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#fff'
};

function SessionsTable({ rows, triggerRefetch, permission, ordersBundle, globalSelected, toggleInSet }) {
  return (
    <TableContainer component={Paper} sx={{width: 'auto', boxShadow: 'none', height: '100%'}}>
      <Table sx={{minWidth: 650}}>
        <TableHead>
          <TableRow>
            { permission === Permission.WRITE
                ? <TableCell align={"center"} style={{ zIndex: 2, width: '74px' }} sx={sticky}><span>#</span></TableCell>
                : null
            }
            <OrderCell id="loginHead" ordersBundle={ordersBundle} label={'Логин'} orderField={'login'} sticky={sticky} />
            <OrderCell id="ipHead" ordersBundle={ordersBundle} label={'IP'} orderField={'ip'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Длительность сеанса'} orderField={'duration'} sticky={sticky} />
            {(permission === Permission.WRITE) ? <TableCell sx={sticky}></TableCell>: ''}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (<SessionsTableRow toggleInSet={toggleInSet} globalSelected={globalSelected} permission={permission} row={row} triggerRefetch={triggerRefetch} key={row.sessionId} />))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SessionsTable;
